import { Typography } from "ui-kit/Typography";
import styles from "./Checkbox.module.css";
import { ReactNode } from "react";

type CheckboxProps = {
  onSelect: () => void;
  selected: boolean;
  label: ReactNode;
  required?: boolean;
};

export const Checkbox = ({
  onSelect,
  selected,
  label,
  required,
}: CheckboxProps) => {
  return (
    <label className={styles.label}>
      <input
        type="checkbox"
        checked={selected}
        onChange={onSelect}
        className={styles.checkbox}
        required={required}
      />
      <Typography variant="body3">{label}</Typography>
    </label>
  );
};
